import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LaptopImg from "../../assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";


const About = () => {
    return (
        <Container fluid className="home-about-section" id="about">
          <Container>
            <Row>
              <Col md={8} className="home-about-description">
                <h1 style={{ fontSize: "2.6em" }}>
                  LET ME <span className="yellow"> INTRODUCE </span> MYSELF
                </h1>
                <p className="home-about-body">
                 Hi, I'm <span className="yellow">Aman Sharma. </span>
                 a Frontend Developer and a Computer Science student at VIT Chennai. With a passion for technology and 
                 problem-solving, I am constantly learning and expanding my skill set.
                 <br />
                 <br />
                 Currently, I am interning as a <b className="yellow">Frontend Developer at Trademarkia</b>, where I am gaining hands-on 
                 experience with modern JavaScript frameworks like <b className="yellow">Next.js, React.js and Express.js</b>. I am skilled in 
                 <b className="yellow">Javascript</b>, with proficiency in C and C++ and am always eager to learn new technologies.
                  <br />
                  <br />
                  In addition to my development skills, I am <b className="yellow">fascinated by system architecture</b> and the way different 
                  applications are designed, built, and scaled. I enjoy understanding how all the components of a system 
                  interact and how to design efficient, scalable solutions.
                  <br />
                  <br />
                  I am always <b className="yellow">seeking new challenges and opportunities to grow</b>, whether it's in building applications
                  , exploring AI concepts, or optimizing systems.
                  <br />
                </p>
              </Col>
              <Col md={4} className="myAvtar">
                <Tilt>
                  <img src={LaptopImg} className="img-fluid" alt="avatar" />
                </Tilt>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="home-about-social">
                <h1>FIND ME ON</h1>
                <ul className="home-about-social-links">
                  <li className="social-icons flex justify-center items-center">
                    <a
                      href="https://github.com/Aman-Sharma-03/"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour home-social-icons"
                      aria-label="github"
                    >
                      <AiFillGithub />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://x.com/aman_sharma2703"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                      aria-label="twitter"
                    >
                      <AiOutlineTwitter />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                    href="https://www.linkedin.com/in/aman-sharma-885a59216/"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                      aria-label="linkedin"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://www.instagram.com/jaiiisharrma"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour home-social-icons"
                      aria-label="instagram"
                    >
                      <AiFillInstagram />
                    </a>
                  </li>
                </ul>
                <p>
                Please don't hesitate to reach out to me and <span className="yellow">connect.</span>
                </p>
              </Col>
            </Row>
          </Container>
        </Container>
      );
    
}

export default About